/* eslint-disable spellcheck/spell-checker */
import {IScript} from '@invitae/nucleobase'

const thirdPartyScripts: IScript[] = [
  {
    conditions: () => process.env.COOKIE_BOT_ID !== undefined,
    ['data-cbid']: process.env.COOKIE_BOT_ID,
    ['data-testid']: 'cookiebot',
    id: 'Cookiebot',
    initializeArea: 'bottom',
    src: 'https://consent.cookiebot.com/uc.js',
  },
]

export default thirdPartyScripts
/* eslint-enable spellcheck/spell-checker */
